import { Button, Card, CardContent } from "@devhop/ui";
import { FileText } from "lucide-react";
import type { FormItemDTO } from "@/modules/document-portal/domain/contracts";

type FormDocumentCardProps = {
  item: FormItemDTO;
  onOpenDetail?: (id: string) => void;
};

export function FormDocumentCard({
  item,
  onOpenDetail,
}: FormDocumentCardProps) {
  const description = item.description?.trim() ?? "";

  return (
    <Card className="overflow-hidden transition-colors hover:border-black/30">
      <CardContent className="p-4 py-0">
        <div className="mb-3 flex items-start justify-between">
          <div className="flex min-w-0 flex-1 items-center gap-2">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-black/5">
              <FileText className="size-5 text-black" />
            </div>
            <div className="min-w-0">
              <h4 className="font-semibold text-base">{item.name}</h4>
              <p className="mb-1 font-medium text-muted-foreground text-xs uppercase tracking-wide">
                {item.category}
              </p>
            </div>
          </div>
          {/* <span className="shrink-0 rounded bg-muted px-2 py-0.5 text-xs font-medium text-muted-foreground">
            {item.fileType}
          </span> */}
        </div>
        {item.nameEn && (
          <p className="mb-2 text-muted-foreground text-xs">{item.nameEn}</p>
        )}
        {description ? (
          <div className="mb-4 min-h-[2.5rem]" title={description}>
            <p className="line-clamp-2 text-muted-foreground text-xs leading-relaxed">
              {description}
            </p>
          </div>
        ) : null}
        <Button
          variant="outline"
          className="w-full border-black font-medium hover:bg-black hover:text-white"
          onClick={() => onOpenDetail?.(item.id)}
        >
          ເບິ່ງລາຍລະອຽດ
        </Button>
      </CardContent>
    </Card>
  );
}
